import { motion } from "framer-motion";
import { PRICE_CARD } from "../lib/materials";
import { fadeUp, viewportOnce } from "../lib/motion";

const Row = ({ label, value }) => (
    <div className="flex items-center justify-between border-b border-white/[0.07] px-6 py-4">
        <span className="font-mono text-[13px] tracking-[0.22em] text-cad">
            {label}
        </span>
        <span className="text-[15px] text-white/90">{value}</span>
    </div>
);

const PriceCard = () => (
    <section
        id="price-card"
        data-testid="price-card-section"
        className="relative border-y border-white/10 bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    VERIFIED PRICING
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    SAMPLE UI
                </p>
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mx-auto mt-14 max-w-lg"
            >
                <div className="mb-4 flex items-center justify-between font-mono text-[13px] tracking-[0.2em] text-cad">
                    <span>FIG. P.01 — VERIFIED PRICE CARD</span>
                    <span>1 : 1</span>
                </div>

                <div
                    data-testid="verified-price-card"
                    className="border border-white/15 bg-[#0C1428] shadow-[0_24px_60px_rgba(0,0,0,0.45)]"
                >
                    <div className="flex items-start justify-between border-b border-white/10 px-6 py-5">
                        <div>
                            <p className="font-mono text-[13px] tracking-[0.22em] text-cad">
                                PRODUCT
                            </p>
                            <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-white">
                                {PRICE_CARD.product}
                            </h3>
                        </div>
                        <span className="border border-accent/60 px-2.5 py-1 font-mono text-[13px] tracking-[0.22em] text-accent">
                            SAMPLE UI
                        </span>
                    </div>

                    <Row label="SUPPLIER" value={PRICE_CARD.supplier} />
                    <Row label="LOCATION" value={PRICE_CARD.location} />
                    <Row label="VAT" value={PRICE_CARD.vat} />
                    <Row label="DELIVERY" value={PRICE_CARD.delivery} />

                    <div className="flex items-end justify-between border-b border-white/10 px-6 py-6">
                        <div>
                            <p className="font-mono text-[13px] tracking-[0.22em] text-cad">
                                PRICE
                            </p>
                            <p
                                data-testid="verified-price-value"
                                className="mt-2 font-display text-4xl font-semibold tracking-tight text-white md:text-5xl"
                            >
                                {PRICE_CARD.price}
                            </p>
                        </div>
                        <span
                            data-testid="verified-price-status"
                            className="flex items-center gap-2.5 pb-1 font-mono text-[13px] tracking-[0.22em] text-emerald-400"
                        >
                            <motion.span
                                animate={{ opacity: [1, 0.35, 1] }}
                                transition={{
                                    duration: 2.2,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                                className="h-1.5 w-1.5 rounded-full bg-emerald-400"
                            />
                            {PRICE_CARD.status}
                        </span>
                    </div>

                    <p className="px-6 py-4 font-mono text-[13px] tracking-[0.2em] text-mist">
                        ILLUSTRATIVE DATA — NOT A LIVE SUPPLIER PRICE
                    </p>
                </div>
            </motion.div>
        </div>
    </section>
);

export default PriceCard;
